// extracted by mini-css-extract-plugin
export default {"layout_section":"layout_layout_section__dtkK2","layout_child":"layout_layout_child__iVvzp","layout_child_inactive":"layout_layout_child_inactive__5UFs2"};